import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthUserModel } from 'src/app/auth/auth-user.model';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ReportIssueService } from './report-issue.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-report-issue',
  templateUrl: './report-issue.component.html',
  styleUrls: ['./report-issue.component.scss']
})
export class ReportIssueComponent implements OnInit {

  faSend = faPaperPlane;
  user: AuthUserModel;
  authenticatedUser: AuthUserModel;
  reportIssueForm: FormGroup;
  textFormControl = new FormControl();

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private reportIssueService: ReportIssueService,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.reportIssueForm = this.formBuilder.group({
      textFormControl: this.textFormControl
    });
  }

  ngOnInit(): void {
    this.authenticatedUser = this.authService.authenticatedUser;
  }

  onSubmit(): void {
    const issue = { userId: this.authenticatedUser.id, text: this.textFormControl.value }

    this.reportIssueService.reportIssue(issue)
      .subscribe(response => {
        if (response.model) {
          this.toastr.success(this.translateService.instant('ui-api.report-issue.report-issue-success'));
          return;
        }        
        if (response.error.message) {
          this.toastr.error(this.translateService.instant(response.error.message));
        }
      });
  }

}
